import * as core from '@actions/core';
import { cleanupSavedStorage } from './run-storage';

try {
  cleanupSavedStorage();
} catch (error) {
  core.setFailed(error instanceof Error ? error.message : String(error));
}
